import TeacherProfile from './TeacherProfile';

export default TeacherProfile;
